import { pick } from 'lodash';

import type { Customer } from '@ctct/infrastructure-layer';

export class RatingRequestCustomer {
  public static fromJson(json: Customer): RatingRequestCustomer {
    return new RatingRequestCustomer(json);
  }

  constructor(private readonly values: Customer) {}

  public toJson(): Customer {
    return this.values;
  }

  public getTaxData(): Pick<Customer, 'address1' | 'city' | 'zipcode' | 'country' | 'state'> {
    return pick(this.values, ['address1', 'city', 'zipcode', 'country', 'state']);
  }

  public withCurrencyCode(currencyCode: string): RatingRequestCustomer {
    return new RatingRequestCustomer({
      ...this.values,
      currencyCd: currencyCode,
    });
  }

  public withPartialUpdate(partial: Partial<Customer>): RatingRequestCustomer {
    return new RatingRequestCustomer({
      ...this.values,
      ...partial,
    });
  }
}
